window.addEventListener('DOMContentLoaded', function () {
  jQuery(function ($) {
    window.theme.productSellingBlockCarousel = new Swiper(
      '.product-selling-block.swiper',
      {
        slidesPerView: 1.25,
        spaceBetween: 8,
        slidesPerGroup: 1,
        navigation: {
          nextEl: '.product-selling-block-navigation .next',
          prevEl: '.product-selling-block-navigation .prev',
        },
        breakpoints: {
          768: {
            slidesPerView: 2.5,
            slidesPerGroup: 2,
          },
          1280: {
            slidesPerView: 'auto',
            slidesPerGroupAuto: true,
          },
        },
      },
    );
  });
});
